/* ============================================================
   KN LUX — Shipping Protection promo in the cart drawer.
   A small opt-in row above the checkout button. Reads the live
   cart to set its own state, adds or removes the protection
   line, then asks the drawer to refresh.
   The row hides itself whenever the cart is empty.
   ============================================================ */
(function () {
  "use strict";

  var VARIANT = 46592793837782;   // Shipping Protection

  var row = document.getElementById("shipguard");
  var box = document.getElementById("shipguardBox");
  if (!row || !box) return;

  var busy = false;

  function setBusy(v) {
    busy = v;
    row.classList.toggle("is-busy", v);
  }

  function readCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  /* Show the row only when there is something to protect, and keep the
     checkbox honest about what is actually in the cart. */
  function sync() {
    return readCart().then(function (cart) {
      if (!cart) return;
      var has = false, other = 0;
      cart.items.forEach(function (i) {
        if (i.variant_id === VARIANT || i.id === VARIANT) has = true;
        else other += i.quantity;
      });
      row.hidden = other === 0;
      box.checked = has;
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    });
  }

  box.addEventListener("change", function () {
    if (busy) return;
    setBusy(true);
    var wanted = box.checked;
    var req = wanted
      ? post("/cart/add.js", { id: VARIANT, quantity: 1 })
      : post("/cart/change.js", { id: String(VARIANT), quantity: 0 });

    req.then(function () {
      if (window.KNCart && window.KNCart.refresh) return window.KNCart.refresh();
    }).then(function () {
      return sync();
    }).catch(function () {
      box.checked = !wanted;   // put the control back if the call failed
    }).then(function () {
      setBusy(false);
    });
  });

  /* Re-sync whenever the drawer opens or the cart changes. */
  document.addEventListener("click", function (e) {
    if (e.target.closest("#cartBtn, .pcard__add, #addBtn, #addBtnSticky, [data-add-variant]")) {
      setTimeout(sync, 900);
    }
  });
  document.addEventListener("cart:added", function () { setTimeout(sync, 600); });

  var drawer = document.getElementById("cartDrawer");
  if (drawer && "MutationObserver" in window) {
    var mo = new MutationObserver(function () { if (!busy) sync(); });
    mo.observe(drawer, { attributes: true, attributeFilter: ["class"] });
  }

  sync();
})();
